import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table,
    Radio, 
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateLdap, deleteTemplateLdap, putTemplateLdap
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentLDAP = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [useSSL, setUseSSL] = useState<boolean>(true);
    const [dataForm] = Form.useForm();

    const { t } = useTranslation();

    var addClick = () => { setShowTable(2) }

    useEffect(() => { getDataInfo() }, [])

    const getDataInfo = () => {
        getTemplateLdap(templateId).then((res) => {
            if (res.hostName) {
                setShowTable(2);
                setUseSSL(res.useSSL);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            putTemplateLdap(templateId, res).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        })
    }

    const deleteTemplateClick = () => {
        deleteTemplateLdap(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            getDataInfo();
        })
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("LDAP")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置LDAP")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ marginLeft: 45 }}>
                        <Form
                            style={{ width: "90%", marginTop: 16 }}
                            layout="vertical"
                            form={dataForm}
                            labelCol={{ span: 20 }}
                            initialValues={{ useSSL: useSSL }}
                        >
                            <Item label={t("Host Name")} name="hostName" rules={[{ required: true }]}>
                                <Input />
                            </Item>

                            <Item label={t("用户名")} name="userName" rules={[{ required: true }]}>
                                <Input />
                            </Item>

                            <Item label={t("密码")} name="password" rules={[{ required: true }]}>
                                <Input.Password />
                            </Item>

                            <Item label={t("UseSSL")} name="useSSL" rules={[{ required: true }]} >
                                <Radio.Group >
                                    <Radio value={true}>{t("是")}</Radio>
                                    <Radio value={false}>{t("否")}</Radio>
                                </Radio.Group>
                            </Item>
                        </Form>

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick();}}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
            </Row>
        </div>

    </>)
};